<template>
  <div>
    <div
      style="padding:12px 16px;display: flex;align-items: center;margin-bottom: 10px;margin-top: 10px;">
      <img src="../../../assets/images/icon_yunying.png" alt="" style="width: 20px;height: 20px;">
      <span style="color: #0E193B;font-size: 14px;margin-left: 8px;">{{ $t('龙翼简报.运营分析') }}</span>
    </div>

    <div class="chart-wrapper" style="position: relative;">
      <div style="text-align: center;position: absolute;left: 39%;z-index: 999;top: 0%;">
        <el-radio-group v-model="localCurrentTab" size="small" @change="handleTabChange">
          <el-radio-button label="里程统计">{{ $t('龙翼简报.里程统计') }}</el-radio-button>
          <el-radio-button label="能耗统计">{{ $t('龙翼简报.能耗统计') }}</el-radio-button>
          <el-radio-button label="运营时长统计">{{ $t('龙翼简报.运营时长统计') }}</el-radio-button>
        </el-radio-group>
      </div>
      <!-- ECharts 容器 -->
      <div class="chart-container" ref="chart" style="width: 100%; height: 400px;"></div>
    </div>
  </div>
</template>
<script>
// import * as echarts from 'echarts';
export default {
  name: "DashboardOperationAnalysis",
  props: {
    chartDataMap: {
      type: Object,
      default: () => ({
        '里程统计': {
          xAxisData: [],
          seriesData1: [],
          seriesData2: [],
          yAxisName1: '',
          yAxisName2: '',
          seriesNames: []
        },
        '能耗统计': {
          xAxisData: [],
          seriesData1: [],
          seriesData2: [],
          yAxisName1: '',
          yAxisName2: '',
          seriesNames: []
        },
        '运营时长统计': {
          xAxisData: [],
          seriesData1: [],
          seriesData2: [],
          yAxisName1: '',
          yAxisName2: '',
          seriesNames: []
        }
      })
    },
    currentTab: {
      type: String,
      default: '里程统计'
    },
    chartUnit: {
      type: String,
      default: 'km'
    }
  },
  data() {
    return {
      localCurrentTab: this.currentTab,
      chart: null
    };
  },
  watch: {
    currentTab: {
      handler(newVal) {
        this.localCurrentTab = newVal;
      },
      immediate: true
    }
  },
  mounted() {
    this.initChart();
    window.addEventListener('resize', this.resizeChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.chart) {
      this.chart.dispose();
    }
  },
  watch: {
    chartDataMap() {
      this.renderChart();
    },
    currentTab() {
      this.renderChart();
    },
    chartUnit() {
      this.renderChart();
    }
  },
  methods: {
    handleTabChange() {
      this.$emit('update:currentTab', this.localCurrentTab);
    },
    initChart() {
      this.chart = echarts.init(this.$refs.chart);
      this.renderChart();
    },
    renderChart() {
      if (!this.chart) return;
      
      const data = this.chartDataMap[this.localCurrentTab];
      const option = {
        title: {
          left: 'center',
          textStyle: {
            color: '#333',
            fontWeight: 'normal'
          }
        },
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
          borderColor: '#eee',
          borderWidth: 1,
          textStyle: { color: '#333' },
          formatter: (params) => {
            let tip = `<div style="font-weight: bold;">${params[0].name}</div>`;
            params.forEach(item => {
              tip += `<div style="color:${item.color}">● ${item.seriesName}: ${item.value} ${this.chartUnit}</div>`;
            });
            return tip;
          }
        },
        legend: {
          data: data.seriesNames,
          type: 'scroll',
          bottom: '5%',
          pageButtonItemGap: 5,
          pageButtonStyle: { color: '#666' }
        },
        grid: {
          left: '3%',
          right: '8%',
          bottom: '15%',
          top: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: data.xAxisData,
          axisTick: { show: false },
          axisLine: {
            lineStyle: { color: '#999' }
          },
          axisLabel: {
            color: '#0F1A3A',
            interval: 0,
            rotate: 0
          }
        },
        yAxis: [
          {
            type: 'value',
            name: data.yAxisName1,
            axisTick: { show: false },
            axisLine: {
              lineStyle: { color: '#999' }
            },
            axisLabel: { color: '#666' },
            splitLine: {
              lineStyle: {
                color: '#eee',
                type: 'dashed'
              }
            }
          },
          {
            type: 'value',
            name: data.yAxisName2,
            axisTick: { show: false },
            axisLine: {
              lineStyle: { color: '#999' }
            },
            axisLabel: { color: '#666' },
            splitLine: { show: false },
            position: 'right'
          }
        ],
        series: [
          {
            name: data.seriesNames[0],
            type: 'bar',
            data: data.seriesData1,
            yAxisIndex: 0,
            barWidth: 15,
            itemStyle: {
              borderRadius: [2, 2, 0, 0],
              color: '#2A7AFF'
            }
          },
          {
            name: data.seriesNames[1],
            type: 'line',
            data: data.seriesData2,
            yAxisIndex: 1,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#07B477' },
            lineStyle: { width: 2, color: '#07B477' },
          }
        ]
      };

      this.chart.setOption(option);
    },
    resizeChart() {
      if (this.chart) {
        this.chart.resize();
      }
    }
  }
};
</script>
<style scoped>
.chart-wrapper {
  width: 100%;
  margin: 0 auto;
}

.chart-container {
  margin-top: 20px;
}
</style>